import clsx from "clsx";

type TabType<T> = {
  label?: string;
  name: T;
  count?: number;
};

export const Tabs = <T extends string>({
  countClassName,
  currentTab,
  isFullWidth,
  tabs,
  onSelect,
}: {
  countClassName?: string;
  currentTab: T;
  isFullWidth?: boolean;
  tabs: TabType<T>[];
  onSelect?: (tab: T) => void;
}) => {
  return (
    <nav
      className={clsx(isFullWidth ? "space-x-0" : "space-x-4", "-mb-px flex")}
      aria-label="Tabs"
    >
      {tabs.map((tab, index) => (
        <button
          key={index}
          className={clsx(
            isFullWidth
              ? "inline-flex w-full justify-center text-base font-normal"
              : "text-sm font-medium",
            tab.name === currentTab
              ? "border-primary text-primary"
              : "border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700",
            "flex items-center whitespace-nowrap border-b-2 py-4 px-1",
          )}
          onClick={() => onSelect(tab.name)}
        >
          <span>{tab.label ?? tab.name}</span>
          {typeof tab.count !== "undefined" && (
            <span
              className={clsx(
                !isFullWidth && !tab.count ? "hidden" : "",
                tab.name === currentTab
                  ? "bg-secondary text-primary"
                  : "bg-gray-100 text-gray-900",
                "ml-2 inline-flex items-center rounded-full py-0.5 px-2.5 text-xs font-medium",
                countClassName,
              )}
            >
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </nav>
  );
};
